module.exports = __webpack_public_path__ + "media/images/company/cp05-8b3a65c0629b541b05a043f357526c78.png";